import { fetcher } from '@commenda/utils';

const deleteDatasource = async (datasourceId: string) => {
  const response = await fetcher(`datasource/${datasourceId}`, {
    method: 'DELETE',
  });

  return response;
};

export { deleteDatasource };
